import { IOption } from 'common/ui/interfaces/selectors';
import { RestrictionEnum } from '../enums/restriction.enum';

export const RestrictionLabel = {
  [RestrictionEnum.WCL]: 'WCL',
  [RestrictionEnum.L]: 'L',
  [RestrictionEnum.Z]: 'Z',
  [RestrictionEnum.E]: 'E',
  [RestrictionEnum.X]: 'X',
  [RestrictionEnum.O]: 'O',
  [RestrictionEnum.K]: 'K',
  [RestrictionEnum.V]: 'V',
  [RestrictionEnum.M]: 'M',
  [RestrictionEnum.N]: 'N',
  [RestrictionEnum.B]: 'B',
  [RestrictionEnum.A]: 'A',
};

export const RestrictionOptions: IOption[] = Object.entries(
  RestrictionLabel
).map(([value, label]: [string, string]) => ({ value, label }));
